import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ConstraintBasedOptimizerBO} from "./ConstraintBasedOptimizerBO";
import {WB_CBOConstraintRow, WB_SimulationTypeInputRelationshipRow} from "../PA.Core/PAdbSchemaRows";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";


export class ConstraintBasedOptimizerBOValidation {
    static Validation(aBO: ConstraintBasedOptimizerBO): Promise<void> {

        return new Promise<void> ((resolve, error) => {


            ConstraintBasedOptimizerBOValidation.ValidateDate(aBO)
                .then((ignore) => {
                    if(aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
                    }

                    return ConstraintBasedOptimizerBOValidation.ValidateInputFields(aBO)
                })
                .then((ignore) => {
                    resolve()
                    return;
                })

        })
    }

    static getFormattedDate(date:Date) {
        var year = date.getFullYear();

        var month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : '0' + month;

        var day = date.getDate().toString();
        day = day.length > 1 ? day : '0' + day;

        return month + '/' + day + '/' + year;
    }

    static ValidateDate(aBO: ConstraintBasedOptimizerBO): Promise<void> {
        const self = this;
        return new Promise((resolve, reject) => {
           let message =""

            let simulationDate = aBO.WB_CBO.StartDate
            let publishedModelValidityStartDate = aBO.WB_CBO.WB_PublishedModelRow.EffectiveStartDt
            let publishedModelValidityEndDate = aBO.WB_CBO.WB_PublishedModelRow.EffectiveEndDt

            if (!(simulationDate >= publishedModelValidityStartDate && simulationDate <= publishedModelValidityEndDate))
                message = "Promo Generator Start Date " + ConstraintBasedOptimizerBOValidation.getFormattedDate(simulationDate) + " has to be within Published Model Validity (" + ConstraintBasedOptimizerBOValidation.getFormattedDate(publishedModelValidityStartDate) + '-' + ConstraintBasedOptimizerBOValidation.getFormattedDate(publishedModelValidityEndDate) + ")"


            simulationDate = aBO.WB_CBO.EndDate
            if (!(simulationDate >= publishedModelValidityStartDate && simulationDate <= publishedModelValidityEndDate)) {
                if (!_.isEmpty(message))
                    message += "\r"
                message += "Promo Generator Latest Start Date " + ConstraintBasedOptimizerBOValidation.getFormattedDate(simulationDate) + " has to be within Published Model Validity (" + ConstraintBasedOptimizerBOValidation.getFormattedDate(publishedModelValidityStartDate) + '-' + ConstraintBasedOptimizerBOValidation.getFormattedDate(publishedModelValidityEndDate) + ")"
            }

            if (!_.isEmpty(message)) {
                self.addMessage(aBO, MessageType.Error, "InvalidEndDate", message)

            } else {
                aBO.ValidateMessageProvider.removeMessage("InvalidEndDate")
            }
            resolve()
        })
    }

    static async ValidateInputFields(aBO: ConstraintBasedOptimizerBO): Promise<void> {
        let minMaxValue = false
        const self = this;
        return new Promise<void>((resolve, error) => {
            _.forEach(aBO.drWB_CBO.WB_CBOConstraintRows, (contRow: WB_CBOConstraintRow) => {
                console.log(contRow)
                console.log(contRow.cif.MAX_VALUE)
                console.log(contRow.cif.MIN_VALUE)
                if (_.gt(_.toNumber(contRow.cif.MIN_VALUE), _.toNumber(contRow.cif.MAX_VALUE)))
                    minMaxValue = true

            })
            if (minMaxValue) {
                ErrorMessage_restate(aBO.ValidateMessageProvider,
                    true,
                    'maxMinValue',
                    "Max value must be greater than Min value")
            }
            resolve()

        })


    }
    private static addMessage(aBO: ConstraintBasedOptimizerBO, type:number, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: type,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }

}